import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { PentagoMove } from './PentagoMove';
import { PentagoState } from './PentagoState';
export class PentagoMoveGenerator extends MoveGenerator {
    static FIRST_TURN_MOVES = [
        PentagoMove.rotationless(0, 0),
        PentagoMove.rotationless(1, 0),
        PentagoMove.rotationless(2, 0),
        PentagoMove.rotationless(0, 1),
        PentagoMove.rotationless(1, 1),
        PentagoMove.rotationless(0, 2),
    ];
    getListMoves(node, _config) {
        const moves = [];
        const preDropNeutralBlocks = node.gameState.neutralBlocks;
        if (node.gameState.turn === 0) {
            return PentagoMoveGenerator.FIRST_TURN_MOVES;
        }
        const legalDrops = this.getLegalDrops(node.gameState);
        for (const legalDrop of legalDrops) {
            const drop = PentagoMove.rotationless(legalDrop.x, legalDrop.y);
            const stateAfterDrop = node.gameState.applyLegalDrop(drop);
            const legalRotations = this.getLegalRotations(stateAfterDrop, preDropNeutralBlocks);
            for (const legalRotation of legalRotations) {
                moves.push(PentagoMove.withRotation(legalDrop.x, legalDrop.y, legalRotation[0], legalRotation[1]));
            }
            const mustRotate = stateAfterDrop.neutralBlocks.length === 0;
            if (mustRotate === false) {
                moves.push(drop);
            }
        }
        return moves;
    }
    getLegalDrops(state) {
        const legalDrops = [];
        for (let y = 0; y < PentagoState.SIZE; y++) {
            for (let x = 0; x < PentagoState.SIZE; x++) {
                const coord = new Coord(x, y);
                if (state.getPieceAt(coord).isNone()) {
                    legalDrops.push(coord);
                }
            }
        }
        return legalDrops;
    }
    getLegalRotations(stateAfterDrop, blockNeutralBeforeDrop) {
        const mustRotate = stateAfterDrop.neutralBlocks.length === 0;
        const legalRotations = [];
        for (let blockIndex = 0; blockIndex < 4; blockIndex++) {
            if (stateAfterDrop.blockIsNeutral(blockIndex) === false) {
                if (blockNeutralBeforeDrop.includes(blockIndex)) { // just deneutralized
                    if (mustRotate) {
                        legalRotations.push([blockIndex, true]);
                    }
                }
                else {
                    legalRotations.push([blockIndex, true], [blockIndex, false]);
                }
            }
        }
        return legalRotations;
    }
}
